<div class="container-fluid contact-section">
  <div class="row align-items-center">
    <!-- Left Content -->
    <div class="col-lg-5 col-md-12 contact-content">
      <br />
      <div class="line"></div>
      <h1>Let’s Connect. Your Next Big Idea Starts Here.</h1>
      <p>
        From product inquiries to technical support, our team is available 24/7
        to provide answers, insights, and the right solutions.
      </p>
      <button class="btn" (click)="contact()"> Work Together</button>
    </div>

    <!-- Right Image -->
    <div class="col-lg-7 col-md-12 text-center">
      <img
        src="assets/images/cantact/contact-support.webp"
        alt="Contact Support"
        class="contact-img img-fluid"
        loading="lazy"
      />
    </div>
  </div>
</div>

<!-- Form -->
<div class="container-fluid d-flex justify-content-center" id="form">
  <div class="row contact-info-form">
    <!-- Contact Information -->
    <div class="col-lg-6 col-md-12 info-section">
      <h2 class="section-title text-center">Contact Information</h2>
      <div class="row g-4">
        <div class="col-sm-6 d-flex" *ngFor="let card of contactCards">
          <a
            [href]="card.link"
            [target]="card.newTab ? '_blank' : '_self'"
            rel="noopener noreferrer"
            class="text-decoration-none flex-fill"
          >
            <div class="info-card flex-fill">
              <i class="bi text-center" [ngClass]="card.icon"></i>
              <!-- <h5 class="text-center">{{ card.title }}</h5> -->
              <h5 class="text-center" [innerHTML]="card.title"></h5>
              <p class="text-center">{{ card.text }}</p>
            </div>
          </a>
        </div>
      </div>
    </div>

    <!-- Right Form -->
    <div class="col-lg-6 col-md-12 form-section">
      <h2 class="section-title text-center">Send us a message</h2>
      <form
  #contactForm="ngForm"
  (ngSubmit)="onSubmit(contactForm)"
  novalidate
>

        <div class="mb-3">
          <label for="name">Name<span class="required">*</span></label>
          <input
            type="text"
            id="name"
            class="form-control"
            placeholder="Your Name"
            [(ngModel)]="contactData.name"
            name="name"
            required
            pattern="^(?!\s*$).+"
          />
          <small class="text-danger" *ngIf="contactForm.submitted && contactForm.controls['name']?.invalid">
  Name is required
</small>
        </div>

        <div class="mb-3">
          <label for="email">Email<span class="required">*</span></label>
          <input
            type="email"
            id="email"
            class="form-control"
            placeholder="Your Email"
            [(ngModel)]="contactData.email"
            name="email"
            required
            email
          />
          <small class="text-danger" *ngIf="contactForm.submitted && contactForm.controls['email']?.invalid">
  Enter a valid email address
</small>
        </div>

        <div class="mb-3">
          <label for="mobile">Phone<span class="required">*</span></label>
          <input
            type="text"
            id="mobile"
            class="form-control"
            placeholder="Your Phone"
            [(ngModel)]="contactData.mobile"
            name="mobile"
            required
            pattern="^[0-9]{10}$"
          />
          <small class="text-danger" *ngIf="contactForm.submitted && contactForm.controls['mobile']?.invalid">
  Enter a valid 10-digit phone number
</small>
        </div>
       

        


        <div class="mb-3">
          <label for="message">Message<span class="required">*</span></label>
          <textarea
            id="message"
            rows="4"
            class="form-control"
            placeholder="Your Message"
            [(ngModel)]="contactData.message"
            name="message"
            required
            pattern="^(?!\s*$).+"
          ></textarea>
          <small class="text-danger" *ngIf="contactForm.submitted && contactForm.controls['message']?.invalid">
  Message cannot be empty
</small>
        </div>

        <!-- 🔹 Captcha -->
        <!-- Captcha -->
        <div class="captcha-container mb-3">
          <label class="form-label">Captcha:</label>
          <div class="captcha-flex">
            <span class="captcha-question">{{ captchaQuestion }}</span>
            <input
              type="text"
              class="form-control captcha-input"
              placeholder="Answer"
              [(ngModel)]="captchaInput"
              name="captchaInput"
              required
            />
          </div>
        </div>

        <button type="submit" class="btn-submit" [disabled]="isSubmitting">
          {{ isSubmitting ? "Sending..." : "Send Message" }}
        </button>
      </form>
    </div>
  </div>
</div>

<!-- Address -->
<div class="contact-map-section container-fluid">
  <div class="row">
    <!-- Map -->
    <div class="col-12">
      <div class="map-container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3836.935150211203!2d80.48410527490054!3d15.912467984744556!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a4a3fbe39e72125%3A0xb535a15ce6f7f6a9!2sMALtech%20Solutions%20Private%20Limited!5e0!3m2!1sen!2sin!4v1758629777993!5m2!1sen!2sin"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        >
        </iframe>
      </div>
    </div>
  </div>
</div>
